/**
 * Customer Portal API
 * See `api-description.md` for detailed description.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Mandate purpose
 */
export type MandatePurpose = 'GENERAL' | 'ENERGY_SUPPLY_OFFER' | 'AGGREGATION_SERVICE' | 'AMPERFLOW_SOLAR_ENERGY_ANALYSIS' | 'AGGREGATION_OFFER' | 'ENERGIATURG_BILLING_AND_ANALYSIS' | 'CREDITINFO_ESG_REPORTING' | 'FENTRICA_INTELLIGENT_ENERGY_SOLUTIONS' | 'GRIDEA_CONSUMPTION_ANALYSIS' | 'R8_TECH_CONSUMPTION_OPTIMIZING' | 'HELLO_ENERGY_BILLING_AND_ANALYSIS' | 'ENERY_PORTFOLIO_OPTIMIZATION_AND_ANALYSIS' | 'HEATLOOP_CONSUMPTION_ANALYSIS_AND_BILLING' | 'MATERIATECH_ENERGY_DATA_ANALYSIS_AND_OPTIMIZATION';

export const MandatePurpose = {
    General: 'GENERAL' as MandatePurpose,
    EnergySupplyOffer: 'ENERGY_SUPPLY_OFFER' as MandatePurpose,
    AggregationService: 'AGGREGATION_SERVICE' as MandatePurpose,
    AmperflowSolarEnergyAnalysis: 'AMPERFLOW_SOLAR_ENERGY_ANALYSIS' as MandatePurpose,
    AggregationOffer: 'AGGREGATION_OFFER' as MandatePurpose,
    EnergiaturgBillingAndAnalysis: 'ENERGIATURG_BILLING_AND_ANALYSIS' as MandatePurpose,
    CreditinfoEsgReporting: 'CREDITINFO_ESG_REPORTING' as MandatePurpose,
    FentricaIntelligentEnergySolutions: 'FENTRICA_INTELLIGENT_ENERGY_SOLUTIONS' as MandatePurpose,
    GrideaConsumptionAnalysis: 'GRIDEA_CONSUMPTION_ANALYSIS' as MandatePurpose,
    R8TechConsumptionOptimizing: 'R8_TECH_CONSUMPTION_OPTIMIZING' as MandatePurpose,
    HelloEnergyBillingAndAnalysis: 'HELLO_ENERGY_BILLING_AND_ANALYSIS' as MandatePurpose,
    EneryPortfolioOptimizationAndAnalysis: 'ENERY_PORTFOLIO_OPTIMIZATION_AND_ANALYSIS' as MandatePurpose,
    HeatloopConsumptionAnalysisAndBilling: 'HEATLOOP_CONSUMPTION_ANALYSIS_AND_BILLING' as MandatePurpose,
    MateriatechEnergyDataAnalysisAndOptimization: 'MATERIATECH_ENERGY_DATA_ANALYSIS_AND_OPTIMIZATION' as MandatePurpose
};

